import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lighten } from 'polished';
import { get } from 'lodash';
import { Row, Col, Label, Alert } from 'react-bootstrap';
import { getDefaultDeliveryPlatform, supportedChannelDisplayNamesKeyed } from 'helpers/channels';
import DeliveryPlatformConfig from 'components/organisms/entity/edit/DeliveryPlatformConfig';

const Spacing = styled.div`
    margin: 10px;
`;

const ChannelWrapper = styled.div`
    overflow: hidden;
    background-color: #ffffff;
    border-bottom: 1px solid ${props => props.theme.colors.darkgray};
`;

const ExpandLink = styled.a`
    cursor: pointer;
    margin-bottom: 5px;
    user-select: none;
`;

const Arrow = styled.span`
    display: inline-block;
    margin-right: 5px;
    transform: ${props => (!props.expanded ? null : 'rotate(90deg)')};
`;

const BorderRow = styled(Row)`
    border-top: 1px solid ${props => props.theme.colors.darkgray};
    display: flex;
    min-height: 35px;
    align-items: center;
    transition: all .5s;

    :hover {
        background-color: ${props => lighten(0.59, props.theme.colors.primary)};

    }
`;

function WorkOrderChannelView(props) {
    const [expanded, setExpanded] = useState(props.expanded || false);

    let channels = null;

    const renderPlatform = (channel) => {
        const deliveryPlatform = get(
            props,
            `workOrder.meta.channels.${channel}[0].deliveryPlatform`,
            getDefaultDeliveryPlatform(
                get(props, 'workOrder.adminPlatform', 'salesforce'),
                channel
            )
        );

        return (
            <DeliveryPlatformConfig channel={channel} deliveryPlatform={deliveryPlatform}/>
        );
    };

    if (expanded) {
        channels = Object.keys(supportedChannelDisplayNamesKeyed).map(channel => (
            <BorderRow key={channel}>
                <Col xs={3}>
                    <Label bsStyle={get(props, `workOrder.meta.channels.${channel}[0].enabled`, null) ? 'success' : 'default'}>
                        {props.workOrder.meta.channels[channel][0].enabled ? 'Enabled' : 'Disabled'}
                    </Label>
                </Col>
                <Col xs={3}>{supportedChannelDisplayNamesKeyed[channel]}</Col>
                <Col xs={4}>
                    {renderPlatform(channel)}
                </Col>
            </BorderRow>
        ));
    }

    return (
        <React.Fragment>
            <Spacing>
                <Row>
                    {props.workOrder.meta.overrideChannels && <Alert bsStyle={'info'} style={{ padding: '0px 3px', marginBottom: '5px', fontSize: '12px', width: 'auto' }}>{`This work order is overriding the default channel settings for the ${props.brand} brand`}</Alert>}
                </Row>
                <ExpandLink onClick={() => setExpanded(!expanded)}>
                    <Arrow expanded={expanded}>►</Arrow>
                    {expanded ? 'Hide' : 'Show'} Channel Config
                </ExpandLink>
            </Spacing>
            {expanded ?
                <React.Fragment>
                    <ChannelWrapper>
                        {channels}
                    </ChannelWrapper>
                </React.Fragment>
                : null}
        </React.Fragment>
    );
}

WorkOrderChannelView.propTypes = {
    workOrder: PropTypes.shape({
        adminPlatform: PropTypes.string,
        id: PropTypes.number.isRequired,
        jobNumber: PropTypes.string,
        jobId: PropTypes.number,
        salesforceId: PropTypes.string,
        meta: PropTypes.object.isRequired,
        workOrderId: PropTypes.string
    }),
};

export default WorkOrderChannelView;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/view/WorkOrderChannelView.js